// extracted by mini-css-extract-plugin
export default {"fileName":"FileName_fileName__3PWgv"};